
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/record-video",
      function () {
        return require("private-next-pages/android/local/record-video/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/record-video"])
      });
    }
  